import axios from 'axios'
import { setupRequestInterceptors, setupResponseInterceptors } from './interceptors'

/**
 * HTTP client configuration
 */
const httpClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 30000,
  withCredentials: true, // Send cookies for cross-origin requests (refresh token)
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

// Setup interceptors
setupRequestInterceptors(httpClient)
setupResponseInterceptors(httpClient)

export { httpClient }
